/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 */

/**
 * @module bulb-media/bulbmediaUi
 */

import { Plugin, createDropdown, addToolbarToDropdown } from 'ckeditor5';
import bulbPlusIcon from '../../assets/block_toolbar_icons/plus-circle-blue.svg';
import { MEDIA_CONFIG } from '../../editorcustomconfig.constant';
/**
 * The bulb media dropdown plugin.
 *
 * @extends Plugin
 */
export default class BulbMediaUi extends Plugin {

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbMediaUi' as const;
  }

  /**
   * @inheritDoc
   */
  public init(): void {
    const { editor } = this;
    const { t } = editor;
    const { options } = MEDIA_CONFIG;

    // Register UI component.
    editor.ui.componentFactory.add('media', (locale) => {
      const dropdownView = createDropdown(locale);

      // Add existing media buttons to dropdown's toolbar.
      const buttons = options.map((option: string) => {
        const mediaButton = editor.ui.componentFactory.create(option) as any;
        if (option === 'insertTable') {
          mediaButton.buttonView.arrowView.content = '';
          mediaButton.buttonView.withText = true;
          mediaButton.buttonView.label = t('content_block_type_TABLE');
        }
        if (option === 'horizontalLine') {
          mediaButton.withText = true;
          mediaButton.label = t('toolbar_horizontal_line');
        }
        return mediaButton;
      });
      addToolbarToDropdown(dropdownView, buttons, {
        enableActiveItemFocusOnDropdownOpen: true,
        isVertical: true,
      });

      // Configure dropdown properties and behavior.
      dropdownView.buttonView.set({
        label: t('Insert media'),
        icon: bulbPlusIcon,
        tooltip: true,
      });

      // panelPosition 'se'(southEast) will set the position of dropdown at bottom right of the button.
      dropdownView.panelPosition = 'se';

      dropdownView.extendTemplate({
        attributes: {
          class: 'ck-media-dropdown',
        },
      });

      return dropdownView;
    });
  }
}
